module.exports = __webpack_public_path__ + "static/media/burger-2.1a92a271.jpg";